import { useState } from "react";

import JourneyLayout from "@/components/JourneyLayout";
import ULThemeCard from "@/components/ULThemeCard";
import ULThemeSubtitle from "@/components/ULThemeSubtitle";
import ULThemeTitle from "@/components/ULThemeTitle";
import { journeySteps } from "@/utils/flow";
import { applyCareSuperBrand } from "@/utils/theme/careSuperBrand";
import { applyAuth0Theme } from "@/utils/theme/themeEngine";

import SignupPasswordForm from "./components/SignupPasswordForm";
import { useSignupPasswordManager } from "./hooks/useSignupPasswordManager";
import locales from "./locales/en.json";

// Sub-steps 1-3 here map onto overall journey steps 3-5 (Personal info,
// Set password, Check details) — see ARCHITECTURE.md "Member Signup Flow"
// and components/Stepper.tsx.
const SUB_STEP_HEADINGS = {
  1: locales.header.personalInfo,
  2: locales.header.setPassword,
  3: locales.header.checkDetails,
} as const;

function SignupPasswordScreen() {
  const { signupPassword, texts, flow } = useSignupPasswordManager();
  const [subStep, setSubStep] = useState<1 | 2 | 3>(1);

  document.title = texts?.pageTitle || locales.page.title;

  applyAuth0Theme(signupPassword);
  applyCareSuperBrand();

  // Flow B's sub-step 1 collects only name + mobile, so "Personal info" would
  // oversell it; and it has no sub-step 3 at all.
  const heading =
    flow === "B" && subStep === 1
      ? { title: locales.header.yourDetails.title, description: locales.header.yourDetails.description }
      : SUB_STEP_HEADINGS[subStep];

  return (
    <JourneyLayout currentStep={2 + subStep} steps={journeySteps(flow)}>
      <ULThemeCard className="theme-universal w-full gap-0">
        <ULThemeTitle>{heading.title}</ULThemeTitle>
        <ULThemeSubtitle>{heading.description}</ULThemeSubtitle>
        <SignupPasswordForm subStep={subStep} onSubStepChange={setSubStep} />
      </ULThemeCard>
    </JourneyLayout>
  );
}

export default SignupPasswordScreen;
